export default "__VITE_ASSET__08c4fc26__"